/**
 * GA4 / GTM — track() push function
 *
 * Pushes a typed event to window.dataLayer for processing by Google Tag Manager.
 *
 * @example
 * import { track } from '@/helpers/tracking';
 *
 * track({ event: 'cta_clicks', link_text: 'Learn more', link_destination: '/about' });
 *
 * @see html/src/helpers/gtmEvents.ts — event type definitions
 */
/**
 * Push a typed GA4/GTM event to window.dataLayer.
 *
 * - SSR safe: no-ops when window is not available
 * - Dev mode: warns via console.warn when a non-event string property is unexpectedly ''
 */
export function track(payload) {
    if (process.env.NODE_ENV !== 'production') {
        const emptyKeys = Object.entries(payload)
            .filter(([k, v]) => k !== 'event' && v === '')
            .map(([k]) => k);
        if (emptyKeys.length) {
            console.warn(`[GA4] Empty string properties in "${payload.event}":`, emptyKeys);
        }
    }
    if (typeof window === 'undefined')
        return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}
